import Linked from 'shared-components/service/Linked'
import styles from './CardBottomLine.module.css'

interface CardBottomLineProps {
  /** The review's bottom line, already trimmed and non-empty (`ProductCardModel.reviewOverview`). */
  overview: string
  /** Same href as the card's score row; the link is omitted when null. */
  reviewUrl: string | null
  /** The card's `review_click` tracker — the component stays free of the catalog hook. */
  onReviewClick?: () => void
}

/**
 * "BOTTOM LINE" — the SoundGuys review's verdict in the card slot the Owners block leaves
 * empty (sponsored-slot contract C0). The card decides when it renders (no Owners block, an
 * overview present); this only draws it. Server-rendered, clamped to four lines.
 */
const CardBottomLine: React.VFC<CardBottomLineProps> = ({ overview, reviewUrl, onReviewClick }) => (
  <section className={styles.root} aria-label="Bottom line">
    <div className={styles.heading}>{'Bottom line'}</div>
    <p className={styles.text}>{overview}</p>
    {reviewUrl && (
      <Linked
        href={reviewUrl}
        className={styles.link}
        target="_blank"
        rel="noopener noreferrer"
        onClick={onReviewClick}
      >
        {'Read our review ›'}
      </Linked>
    )}
  </section>
)

export default CardBottomLine
